(function ($, _app) {
    $(function () {
        _app.utils = _app.utils || {}
        const consoleTracker = (eventData, category, label, action) =>
            console.log('console event tracker',
                {
                    eventData,
                    category,
                    label,
                    action
                });

        const trackEvent = GAEventTracker && typeof GAEventTracker.sendEvent === 'function'
            ? GAEventTracker.sendEvent
            : consoleTracker;

        _app.tracking = {
            sendGaEvent: function (category, label, action, eventData = undefined) {
                try {
                    trackEvent(eventData, category, label, action);
                } catch (err) {
                    console.log(err);
                }
            },
            sendGaClick: function (category, label, eventData = undefined) {
                try {
                    trackEvent(eventData, category, label, 'click');
                } catch (err) {
                    console.log(err);
                }
            },
            sendGaClickForComponent: function ({selector}) {
                const section = $(selector).data('webm-section') || '';
                const clickValue = $(selector).data('webm-clickvalue') || '';

                if (section.length > 0 && clickValue.length > 0) {
                    try {
                        trackEvent(undefined, section, clickValue, 'click');
                    } catch (err) {
                        console.log(err);
                    }
                }
            }
        }
    })
})
(jQuery, app);
